"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteVirtualCategory = void 0;
const routes_1 = require("../../routes");
const deleteVirtualCategory = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.DELETE_VIRTUAL_CATEGORY.applyParams(params);
    await client.delete(url);
};
exports.deleteVirtualCategory = deleteVirtualCategory;
